import { z } from 'zod';

/// Configuração fechada da página pública; nunca aceita CSS, HTML ou endereços de terceiros.
export const portalPageSchema = z
  .object({
    layout: z.enum(['essential', 'visual', 'units', 'showcase']).default('essential'),
    palette: z.enum(['hue', 'mono', 'navy', 'moss', 'wine', 'straw', 'blossom']).default('hue'),
    showSocialLinks: z.boolean().default(false),
    headline: z.string().trim().max(80).default(''),
    /// Nome no alto da página: texto (vazio usa o nome da empresa) ou a Logo principal.
    nameDisplay: z.enum(['text', 'logo']).default('text'),
    title: z.string().trim().max(60).default(''),
    coverId: z.uuid().nullable().default(null),
    /// Ponto da capa que fica visível no recorte, em porcentagem: vertical e horizontal.
    coverPosition: z.number().int().min(0).max(100).default(50),
    coverPositionX: z.number().int().min(0).max(100).default(50),
    /// Zoom da capa em porcentagem; 100 é a imagem cobrindo a moldura sem ampliar.
    coverZoom: z.number().int().min(100).max(400).default(100),
    galleryIds: z.array(z.uuid()).max(4).default([]),
    /// Recorte de cada foto da galeria; foto sem entrada fica centralizada e sem zoom.
    galleryFrames: z
      .array(
        z
          .object({
            id: z.uuid(),
            x: z.number().int().min(0).max(100),
            y: z.number().int().min(0).max(100),
            zoom: z.number().int().min(100).max(400),
          })
          .strict(),
      )
      .max(4)
      .default([]),
    highlights: z
      .array(
        z
          .object({
            unitId: z.uuid(),
            serviceIds: z.array(z.uuid()).max(3),
          })
          .strict(),
      )
      .max(100)
      .default([]),
  })
  .strict();
export type PortalPageSettings = z.infer<typeof portalPageSchema>;
export const defaultPortalPage: PortalPageSettings = portalPageSchema.parse({});
